export default __webpack_public_path__ + "static/media/auto-interior-color.c9cb04bc.svg";